/**
 * Constructs an element ID by combining the specified element type and name.
 *
 * @param {('load'|'preload')} elementType - The type of the element. Can either be 'load' or 'preload'.
 * @param {string} name - The name to be included in the element ID.
 * @return {string} The constructed element ID as a string.
 */
export function buildElementId(elementType: 'load' | 'preload', name: string): string {
    return `cg-${elementType}-checkout-${name.toLowerCase()}`;
}
